import { jsx as o } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { B as s } from "../Button-DQ5ID5KN.js";
const e = i(
  ({ active: r, ...t }, a) => /* @__PURE__ */ o(
    s,
    {
      "aria-pressed": r,
      "data-state": r ? "on" : "off",
      ref: a,
      variant: r ? "active" : "tertiary",
      ...t
    }
  )
);
e.displayName = "Pill";
export {
  e as Pill
};
